import { render, staticRenderFns } from "./CheckCommission.vue?vue&type=template&id=776bf639&scoped=true"
import script from "./CheckCommission.vue?vue&type=script&lang=js"
export * from "./CheckCommission.vue?vue&type=script&lang=js"
import style0 from "./CheckCommission.vue?vue&type=style&index=0&id=776bf639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776bf639",
  null
  
)

export default component.exports